import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { DepartmentPage } from '@features/groups/components/pages/DepartmentPage'
import { departmentQueryOptions, groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/faculty/$departmentId/')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(departmentQueryOptions({ mode: 'id', id: params.departmentId }))
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'id', identifier: params.departmentId, type: 'programme' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load department'>
            <Suspense fallback={<LoadingIndicator resource='department' />}>
                <DepartmentPage mode='id' navMode='my' id={Route.useParams().departmentId} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
